var React = require('react');

function Kabes (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"kabes","d":"M6.006,127.379q0-51.141,28.557-77.272t81.565-26.131v32.1q-22.024,0-34.343,6.159A48.7,48.7,0,0,0,62.373,79.224a53.737,53.737,0,0,0-8.212,17.358,61.555,61.555,0,0,0-2.24,14.745q5.226-5.226,19.038-5.226,21.278,0,35.09,14.558T119.861,156.5q0,22.024-14.558,36.956T66.48,208.384q-26.877,0-43.675-20.718T6.006,127.379Zm133.639,0q0-52.634,29.49-78.019T249.02,23.977v32.1q-24.637,0-35.65,7.279T196.386,79.224a70.856,70.856,0,0,0-8.4,17.358,51.282,51.282,0,0,0-2.426,14.745q3.733-5.226,18.291-5.226,21.278,0,35.463,14.558T253.5,156.5q0,22.024-14.745,36.956t-39.383,14.932q-26.877,0-43.3-20.718T139.645,127.379Z","transform":"translate(-6.006 -23.977)"}));
}

Kabes.defaultProps = {"width":"247.494","height":"184.407","viewBox":"0 0 247.494 184.407"};

module.exports = Kabes;

Kabes.default = Kabes;
